import React from "react";
import { Images } from "../assets/assets";
import Image from "next/image";
import parse from "html-react-parser";
interface Survey {
  overallOverview?: string | undefined;
  schedule?: number;
  quality?: number;
  cost?: number;
  willingRefer?: number;
  overall?: number;
}
interface SurveySectionProps {
  survey: Survey;
}
export default function SurveyAnalytics({ survey }: SurveySectionProps) {
  const total = 5;
  return (
    <section className="2xl:pt-[120px] pt-[50px] bg-[#ECEEF0]">
      <div className="max-w-[2500px] mx-auto w-[calc(100%_-_10%)] flex flex-col 2xl:flex-row">
        <div className="flex flex-col gap-[20px] flex-1">
          <div
            className="justify-center text-[#00040b]
                    font-[400] text-lg uppercase tracking-tight"
          >
            Survey
          </div>
          <div className="relative flex-1 hidden md:flex">
            <Image
              src={Images?.clutch_survey}
              alt="about us"
              fill
              sizes="(max-width: 1024px) 100vw, 33vw"
              priority
              fetchPriority="high"
              className="w-[300px] max-w-full mt-auto mb-[70px] object-contain"
            />
          </div>
        </div>

        <div className="flex flex-col gap-[10px] flex-[2]">
          {/* Overview Text */}
          <div className="text-[#00040b] clash-font font-medium text-[length:var(--about-para)] leading-[var(--about-para-leading)]">
            {parse(survey?.overallOverview ?? "")}
          </div>

          {/* Stats Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 border border-[rgba(99,99,100,0.2)] divide-y sm:divide-y md:divide-y-0 md:divide-x divide-[rgba(99,99,100,0.2)] lg:mt-[100px] mt-[20px] border-b-0">
            {/* Schedule */}
            <div className="flex flex-col items-start justify-center px-4 sm:px-8 py-8 sm:py-12 lg:py-16">
              <h3 className="text-[#00040b] clash-font font-bold text-[length:var(--about-stat-number)] leading-none">
                {survey?.schedule}/{total}
              </h3>
              <p className="text-[#636364] font-normal text-[length:var(--about-stat-label)] mt-2">
                Schedule
              </p>
            </div>

            {/* Quality */}
            <div className="flex flex-col items-start justify-center px-4 sm:px-8 py-8 sm:py-12 lg:py-16">
              <h3 className="text-[#00040b] clash-font font-bold text-[length:var(--about-stat-number)] leading-none">
                {survey?.quality}/{total}
              </h3>
              <p className="text-[#636364] font-normal text-[length:var(--about-stat-label)] mt-2">
                Quality
              </p>
            </div>

            {/* Cost */}
            <div className="flex flex-col items-start justify-center px-4 sm:px-8 py-8 sm:py-12 lg:py-16">
              <h3 className="text-[#00040b] clash-font font-bold text-[length:var(--about-stat-number)] leading-none">
                {survey?.cost}/{total}
              </h3>
              <p className="text-[#636364] font-normal text-[length:var(--about-stat-label)] mt-2">
                Cost
              </p>
            </div>

            {/* Willing to Refer */}
            <div className="flex flex-col items-start justify-center px-4 sm:px-8 py-8 sm:py-12 lg:py-16">
              <h3 className="text-[#00040b] clash-font font-bold text-[length:var(--about-stat-number)] leading-none">
                {survey?.willingRefer}/{total}
              </h3>
              <p className="text-[#636364] font-normal text-[length:var(--about-stat-label)] mt-2">
                Willing to refers
              </p>
            </div>

            {/* Overall Ratings */}
            <div className="flex flex-col items-start justify-center px-4 sm:px-8 py-8 sm:py-12 lg:py-16">
              <h3 className="text-[#00040b] clash-font font-bold text-[length:var(--about-stat-number)] leading-none">
                {survey?.overall}/{total}
              </h3>
              <p className="text-[#636364] font-normal text-[length:var(--about-stat-label)] mt-2">
                Overall Ratings
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
